(ns vit-configurator.core
  (:require [reagent.core :as reagent]
            [re-frame.core :as re-frame]
            [vit-configurator.events :as events]
            [vit-configurator.views :as views]
            [vit-configurator.config :as config]
            [vit-configurator.auth :as auth]))

(defn dev-setup []
  (when config/debug?
    (enable-console-print!)
    (println "dev mode")))

(defn mount-root []
  (re-frame/clear-subscription-cache!)
  (reagent/render [views/home-panel]
                  (.getElementById js/document "app")))

(defn handshake
  "An event handler that gets fired by the preview iframe posting
   a message to the parent window. This lets us store the DOM element
   for the iframe, which can then be used to post messages back to it
   in a secure manner, such as for loading a new configuration."
  [evt]
  (re-frame/dispatch [::events/preview-ready (.-source evt)]))

(defn ^:export init []
  (re-frame/dispatch-sync [::events/initialize-db (merge
                                                   {:auth-required? auth/auth-required?}
                                                   (config/get-vit-preview-env))])
  (dev-setup)
  (when auth/auth-required?
    (if (auth/redirect-callback?)
      (re-frame/dispatch [::auth/redirect-callback])
      (re-frame/dispatch [::auth/initialize])))
  (.addEventListener js/window "message" handshake)
  (mount-root))
